export enum ProductType {
  GOOGLE = 'GO',
  INSTAGRAM = 'IG',
  MENU = 'ME',
  TIKTOK = 'TT',
  FACEBOOK = 'FB',
  CUSTOM = 'CU',
  BUSINESS_CARD = 'BC',
}
